import * as React from "react"
import { ReactComponent as Spinner } from '../../../../../Assets/spinner.svg'
import { buttonLinkClick } from "../../RenderButton"

interface Props {
  name: string
  variant: string
  link?: string
  buttonType?: "button" | "submit" | "reset"
  loading?: boolean
  disabled?: boolean
  classes?: string,
  target?: string
  componentName?: string
}

/**
 * Outline Button Component
 * @param name - Name of the button.
 * @param variant - Variation of the button. Expected values: "light" | "dark"
 * @param link (optional) - Page to be navigate on click of the button.
 * @param buttonType (optional) - Type of the button. Expected values:  "button" | "submit" | "reset", Default: "button"
 * @param loading (optional) - Loading of the button. Expected values:  true | false
 * @param disabled (optional) - Button to be disabled. Expected values:  true | false
 * @param classes (optional) - Tailwindcss classes to customize it.
 * @param target (optional) - Open url in new tab or not. Expected values: "_blank" | "_self". Default: "_self"
 * @param componentName (optional) - Name of the component from the contentful.
 */
const OutlineButton = ({ name, variant, buttonType = "button", link, loading, disabled, classes, target="_self", componentName }: Props) => {

  return (
    <>
      {variant === "light" && (<>
        <button aria-label={name} type={buttonType} className={`flex justify-center items-center text-base md:text-md rounded-lg 
            px-24 py-16
            ${loading ? 'bg-neutral-30 text-purple-100 border-white border pointer-events-none' : 'bg-transparent text-white border-neutral-50 border' }
            hover:bg-white hover:text-purple-100
            active:bg-neutral-30 active:text-purple-100 active:border-white active:border
            disabled:bg-neutral-30 disabled:border disabled:border-neutral-50 disabled:text-neutral-60 disabled:pointer-events-none
            visited:bg-neutral-30 visited:text-purple-100 visited:border-white visited:border
            ${classes ? classes : ''}`}
            disabled={disabled}
            onClick={buttonType === 'button' ? (e: any) => buttonLinkClick(e, name, link, target, componentName) : undefined}
            data-testid="lightOutlineButton"
        >
          {loading ? <Spinner className="animate-spin" /> : <span>{name}</span>}
        </button>
        </>
      )}
      {variant === "dark" && (<>
        <button aria-label={name} type={buttonType} className={`flex justify-center items-center text-base md:text-md rounded-lg 
            px-24 py-16
            ${loading ? 'bg-purple-hoverDark text-white border-purple-hoverDark border pointer-events-none' : 'bg-transparent text-purple-100 border-purple-100 border' }
            hover:bg-purple-100 hover:text-white hover:border-purple-100
            active:bg-purple-hoverDark active:text-white active:border-purple-100 active:border
            disabled:bg-neutral-30 disabled:border disabled:border-neutral-50 disabled:text-neutral-60 disabled:pointer-events-none
            visited:bg-purple-hoverDark visited:text-white visited:border-purple-100 visited:border
            ${classes ? classes : ''}`}
            disabled={disabled}
            onClick={buttonType === 'button' ? (e: any) => buttonLinkClick(e, name, link, target) : undefined}
            data-testid="darkOutlineButton"
        >
          {loading ? <Spinner className="animate-spin" /> : <span>{name}</span>}
        </button>
        </>
      )}
    </>
  )
}

export default OutlineButton
